import axios from 'axios';
import * as loadingActions from './loading.js';

export const loadContactStart = () => ({
  type: 'LOAD_CONTACT_START'
});

export const loadContactSuccess = contactData => ({
  type: 'LOAD_CONTACT_SUCCESS',
  payload: contactData
});

export const loadContactError = error => ({
  type: 'LOAD_CONTACT_ERROR',
  payload: error
});

export function loadContact() {
  return(dispatch, getState) => {
    dispatch(loadingActions.loadingData(getState().loading));
    axios.get('https://api.qiydaarpratt.com/api/v1/blocks').then((response)=>{
      dispatch(loadContactSuccess(response.data));
      dispatch(loadingActions.doneLoadingData(getState().loading));
    }).catch(error => dispatch(loadContactError(error)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/contact.js